<template>
  <component
    :is="link ? 'a' : 'div'"
    @click="$emit('click', {e: $event, link})"
    v-bind="link ? { href: link } : {}"
    class="product-photo"
    :class="{'product-photo--relative': progressbarTotal > 0}"
    v-on="!isTouch && {mouseenter: setSecondaryPhoto, mouseleave: setMainPhoto}"
  >
    <picture class="product-photo__thumb" :title="title">
      <source v-if="mobileImageUrl" media="(max-width: 768px)" :data-srcset="mobileImageUrl">
      <img
        loading="lazy"
        data-force-load="true"
        ref="img"
        :src="imageUrl"
        :alt="title"
        @error="handleImageLoadError"
      />
    </picture>
    <balance-scale :current="progressbarCurrent" :total="progressbarTotal" is-mobile></balance-scale>
  </component>
</template>

<script>
import { isTouch } from '@/mixins/isTouchDevice'
import BalanceScale from '@/components/product/product-page/photo-gallery/BalanceScale'

export default {
  name: 'ProductPhoto',
  mixins: [isTouch],
  components: {
    BalanceScale
  },
  data () {
    return {
      errorsCount: 0
    }
  },
  props: {
    productId: {
      type: [String, Number],
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    mobileImageUrl: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ''
    },
    secondImageUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    progressbarTotal: {
      type: Number,
      default: 0
    },
    progressbarCurrent: {
      type: Number,
      default: 0
    }
  },
  methods: {
    setMainPhoto () {
      // Функция также вызывается с родительского компонента
      if (this.imageUrl && this.secondImageUrl) this.$refs.img.src = this.imageUrl
    },
    setSecondaryPhoto () {
      // Функция также вызывается с родительского компонента
      if (this.imageUrl && this.secondImageUrl) this.$refs.img.src = this.secondImageUrl
    },
    handleImageLoadError (e) {
      if (this.errorsCount < 1) {
        e.target.src = '/shop/catalog/get-product-preview-photo/?id=' + this.productId
        this.errorsCount++
      } else {
        e.target.src = 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 250 250\'%3E%3C/svg%3E'
      }
    }
  },
  watch: {
    imageUrl (value) {
      this.$refs.img.src = value
    }
  }
}
</script>

<style scoped lang="sass">

.product-photo
  display: block

  &--relative
    position: relative

.product-photo__thumb
  position: absolute
  top: 0
  left: 0
  display: block
  width: 100%
  font-size: 8px
  max-width: 120px
  max-height: 120px
  margin: 0 auto
  line-height: 1

  +mmin($tablet)
    position: static
    max-width: 205px
    max-height: 205px

.product-card--not--adaptive .product-photo__thumb
  position: static
  max-width: 205px
  max-height: 205px

.product-card--adaptive-main-page .product-photo__thumb,
.product-card--adaptive-main-page .product-photo__thumb img
  width: 100%

  +mmax(768)
    margin: 0 auto
    display: block
    max-width: 145px

.product-card-comparison .product-photo__thumb
  position: static
  max-width: 90px
  max-height: 90px

  +mmin(800)
    max-width: 145px
    max-height: 145px
</style>
